import { yupResolver } from "@hookform/resolvers/yup";
import { OnboardingFormValues } from "./types";
import { schema } from "./constants";
import { FormProvider, useForm } from "react-hook-form";
import { defaultFormValues as _defaultFormValues } from "./constants";

export interface OnboardingFormProps {
  defaultFormValues?: Partial<OnboardingFormValues>;
  children?: React.ReactNode;
}

export const OnboardingForm = ({
  defaultFormValues,
  children,
}: OnboardingFormProps) => {
  const methods = useForm<OnboardingFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ..._defaultFormValues,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
